import { useEffect, useState } from "react";
import { getPageDetailsAPI } from "../../service/site.service";
import FooterComponent from "../Footer/footer.component";

const formatContent = (text) => {
  if (!text) return "";

  return text
    .split("\n")
    .map((line) => {
      if (/^\d+\.\s.+/.test(line)) {
        return `<strong>${line}</strong>`;
      }
      return line;
    })
    .join("<br />");
};

const CommonPagesComponent = ({ slug }) => {
  const [data, setData] = useState(null);

  const onLoad = async () => {
    const response = await getPageDetailsAPI(slug);
    if (response.status) {
      setData(response.data);
    }
  };

  useEffect(() => {
    onLoad();
  }, [slug]);

  return (
    <div className="ds-container" style={{ maxWidth: 820 }}>
      <div className="ds-page-head">
        <p className="ds-eyebrow">Legal</p>
        <h1>{data?.title}</h1>
      </div>
      <div
        style={{ color: "var(--fg-2)", lineHeight: 1.75, paddingBottom: 56 }}
        dangerouslySetInnerHTML={{
          __html: formatContent(data?.content),
        }}
      />
    </div>
  );
};

export default CommonPagesComponent;
